import { env } from "../env";

export default {
  LOGIN: env.BASE_URL + "/api/v1.0.0/auth/login",
  VERIFY_ACCESS_KEY: env.BASE_URL + "/api/v1.0.0/auth/verify-access-key",
};
